import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/nextera-logo.png";
import ProfileFooter from "../../components/ProfileFooter";

const KycThankYou = () => {
  return (
    <div className="page-user bg-light">
      <div className="page-ath-header">
        <Link to="/" className="page-ath-logo">
          <img src={logo} alt="logo" className="mx-auto" />
        </Link>
      </div>
      <div className="page-header page-header-kyc">
        <div className="container md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-7 text-center">
              <h2 className="page-title">Begin your ID Verification</h2>
              <p className="large">Verify your identity</p>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <div className="kyc-status card mx-lg-4">
                <div className="card-innr">
                  <div className="status status-thank px-md-5">
                    <div className="status-icon">
                      <em className="ti ti-check"></em>
                    </div>
                    <span className="status-text large text-dark">
                      You have completed the process of KYC
                    </span>
                    <p className="px-md-5">
                      We are still waiting for your identity verification. Once
                      our team verifies your identity, you will be notified by
                      email on the next steps.
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-light text-center mgmt-1x mt-4">
                If you have any question, please contact our support team at
                <a href="mailto:contact@nexteraenergy.live">
                  {" "}
                  contact@nexteraenergy.live
                </a>
                .
              </p>
              <div className="gaps-1x"></div>
              <div className="gaps-3x d-none d-sm-block"></div>
            </div>
          </div>
        </div>
      </div>
      <ProfileFooter />
    </div>
  );
};

export default KycThankYou;
